import { Component, Input } from '@angular/core';

declare var require: any;

@Component({
    selector: 'custom-footer',
    template: require('./custom-footer.component.html')
})
export class CustomFooterComponent{

    private legendState = "void";

    @Input()
    public isLoading:boolean;

    public onClickMapLegend() {
        if (this.legendState == "void") {
            this.legendState = "open";
        }
        else {
            this.legendState = "void";
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/core/components/custom-footer/custom-footer.component.ts